module.exports = __webpack_public_path__ + "static/media/bash.099a3281.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/devops/bash.png
// module id = 1524
// module chunks = 0